(function($){
        
	// Add Loaded Class
	$('.ptx-breadcrumb').addClass('ptx-breadcrumb--loaded');
  
})(jQuery);